var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading d-flex justify-content-center align-items-center flex-column"},[_c('div',{staticClass:"loading-content d-inline-flex justify-content-center align-items-center"},[_c('b-spinner',{staticClass:"mr-2",attrs:{"label":"Spinning","small":""}}),_vm._v(" Loading... ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }